<!--
  --
  -- クーポン入力コンポーネント
  --
  -->
<template>
  <v-text-field
    label="クーポンコード"
    type="text" outlined
    v-model="code"
    :error-messages="error"
    @input="onChange"
    @keydown.enter.prevent="onSubmit"
  >

    <!-- 入力ボタン -->
    <template v-slot:append>
      <v-btn
        type="button"
        depressed small
        color="primary"
        style="margin-top: -2px;"
        :loading="running"
        :disabled="!!error || running"
        @click="onSubmit"
      >
        <span>入力</span>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
import * as api from '@/api'
import * as http from '@/libs/http'
import { run } from '@/libs/a'

export default {
  name: 'CCouponField',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },

  data: () => ({
    // クーポンコード
    code: '',

    // エラー内容
    error: '',

    // 処理中
    running: false
  }),

  created () {
    if (this.value) {
      this.code = this.value.code
    }
  },

  methods: {
    /**
     * クーポンコード
     */
    onChange () {
      // エラーをクリアする
      this.error = ''
    },

    /**
     * クーポンコード入力ボタン
     */
    onSubmit () {
      run(async () => {
        const userID = this.getters['user/id']
        const shopID = this.getters['book/shopID']
        const schedule = this.getters['book/schedule']
        const car = this.getters['book/car']
        const charge = this.getters['book/charge']

        if (this.code) {
        } else {
          this.$emit('change', '')
          return
        }

        this.error = ''
        this.running = true
        const resp = await api.validateCoupon(shopID, {
          userID,
          couponCode: this.code,
          begin: schedule.begin,
          end: schedule.end,
          classID: car.classID,
          chargeBasic: charge.basic,
          chargeSubtotal: charge.total
        })
        this.running = false

        if (resp.status !== http.OK) {
          this.error = resp.data.reason
          return
        }

        // クーポン情報を返す
        this.$emit('change', resp.data)
      })
    }
  }
}
</script>
